(() => {
  // The notification appends this fragment to customer.subscribe_url. Shopify
  // validates the token before redirecting to /password; invalid tokens return
  // an error instead. This is a presentation flag, never proof of consent.
  const confirmationHash = '#casa-waitlist-confirmed';
  const isConfirmation = () => window.location.hash === confirmationHash;
  function updateConfirmation() {
    const confirmed = document.querySelector('[data-casa-confirmed]');
    const signup = document.querySelector('[data-casa-signup]');
    if (!confirmed || !signup) return;
    const active = isConfirmation();
    signup.hidden = active;
    confirmed.hidden = !active;
    if (active) {
      document.title = 'Casa di Ricci | E-Mail bestätigt';
      confirmed.focus({ preventScroll: true });
    } else {
      document.title = 'Casa di Ricci | Werde Teil der Familie';
    }
  }
  function initialize(root = document) {
    root.querySelectorAll('.casa-launch-footer-links').forEach((footer) => {
      if (footer.dataset.casaFooterReady) return;
      const disclosures = [...footer.querySelectorAll('details')];
      const nav = document.createElement('nav');
      nav.className = 'casa-launch-footer-nav';
      nav.setAttribute('aria-label', 'Weitere Informationen');
      const buttons = disclosures.map((details, index) => {
        const summary = details.querySelector('summary');
        const panel = details.querySelector('.casa-launch-disclosure-content');
        panel.id ||= `CasaFooterPanel-${details.name}-${index}`;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'casa-launch-footer-link';
        button.textContent = summary.textContent;
        button.setAttribute('aria-controls', panel.id);
        button.setAttribute('aria-expanded', String(details.open));
        button.addEventListener('click', () => {
          const open = !details.open;
          disclosures.forEach((item, i) => {
            item.open = item === details && open;
            buttons[i].setAttribute('aria-expanded', String(item.open));
          });
        });
        details.addEventListener('toggle', () => button.setAttribute('aria-expanded', String(details.open)));
        nav.append(button);
        return button;
      });
      footer.prepend(nav);
      footer.dataset.casaFooterReady = 'true';
    });
    root.querySelectorAll('.casa-launch-form').forEach((form) => {
      if (form.dataset.casaInitialized) return;
      form.dataset.casaInitialized = 'true';
      const button = form.querySelector('[data-casa-submit]');
      const label = form.querySelector('[data-casa-submit-label]');
      const email = form.querySelector('[type="email"]');
      const originalLabel = label?.textContent;
      const reset = () => {
        if (!button) return;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        label.textContent = originalLabel;
      };
      email?.addEventListener('change', () => { email.value = email.value.trim(); });
      form.addEventListener('submit', () => {
        if (!button || !form.checkValidity()) return;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        label.textContent = 'BITTE WARTEN';
        // Keep Shopify's native POST, validation, consent and challenge handling.
        // Recover if a blocked challenge or lost connection prevents navigation.
        window.setTimeout(reset, 12000);
      });
      window.addEventListener('pageshow', reset);
      form.querySelector('[data-casa-status]')?.focus();
    });
    root.querySelectorAll('.casa-launch-password-form .errors').forEach((error) => {
      error.closest('details')?.setAttribute('open', '');
    });
  }
  initialize();
  updateConfirmation();
  window.addEventListener('hashchange', updateConfirmation);
  window.addEventListener('pageshow', updateConfirmation);
  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
    updateConfirmation();
  });
})();
